const AssignmentStatuses = {
    Filled: "F",
    Cancelled: "C",
    Ended: "E",
    Held: "H",
    Open: "O",
    Staffed: "S",
    F: "Filled",
    C: "Cancelled",
    E: "Ended",
    H: "Held",
    O: "Open",
    S: "Staffed"
};
export default AssignmentStatuses;
